module.exports = __webpack_public_path__ + "static/img/map4_relation.1413bfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map4_relation.jpg
// module id = 5JeJ
// module chunks = 1